<template>
  <div class="business-info-entry">
    <z-fix-top keep-position class="fixtop" headerTaskbarBG="#F8F8F8">
      <z-nav-bar class="navbar" left-arrow title="监督举报" style="background: #F8F8F8" @click-left="closePage">
      </z-nav-bar>
    </z-fix-top>
    <div v-if="showNotice">
      <div class="notice">
        <img :src="soundImg" width="22px" height="17px">
          <div class="text">
            {{reportText[reportSource]}}
        </div>
      </div>
    </div>
    <section class="cell">
      <z-cell-group inset>
      <z-cell class="titlebold" title="举报描述"/>
      <z-field v-model="reportDesc" type="textarea" :maxlength="300" count-word placeholder="请完整描述事件发生经过，便于核查" />
    </z-cell-group>
    </section>

    <section class="cell">
      <z-cell-group inset>
      <z-cell class="titlebold" title="上传证据"/>
      <div class="placeholder">
        请您尽可能提供现存证据，如现场录音/视频/照片、收款凭证、微信聊天记录截图
      </div>
      <div class="upload">
        <z-upload
          v-model="photoVideoFiles"
          ref="audioUploadRef"
          accept="image/*, video/*"
          :max="8"
          dropOriginFile
          :draggable="false"
          @files-added="filesAdded"
          @file-success="fileSuccess"
          @file-click="fileClick"
          btnUploadImg="https://pic2.zhuanstatic.com/zhuanzh/050f9d36-16c1-46dc-849b-5e575f86972b.png"
          btnUploadInfo="上传照片/视频"
          >
        </z-upload>
        <UploadAudio ref="audioUploadRef" @changeLoading="changeAudioLoading"/>
      </div>
    </z-cell-group>
    </section>
    <div v-if="supply == '1'" :style="{marginBottom: '12px'}">
      <ReportInfo :historyInfo="historyInfo"/>
    </div>
    <z-button-group keep-position>
      <z-button size="large" type="primary" :loading="submitLoading" @click="submit" :disabled="canSubmit" @disabled-click="disabledSubmit">提交</z-button>
    </z-button-group>
  </div>
</template>
<script>
import native from '@zz-common/native-adapter';
import { FixTop, NavBar, Cell, CellGroup, Upload, Field, ImagePreview, Button, ButtonGroup, Toast } from '@zz-common/zz-ui';
import UploadAudio from '../components/UploadAudio';
import { getSubmitCaseTrackReport, getCaseTrackStatusByOrderId, supplementCaseTrackReport } from '@api/resourceApi';
import ReportInfo from '../components/ReportInfo'
import { lego } from '@zz-common/lego'
import { queryParams, getCookie } from '@lib/utils';

const query = queryParams()

export default {
  name: 'SuperviseCommit',
  data() {
    return {
      reportSource: query.reportSource || this.$route.query.reportSource,
      orderId: query.orderId || this.$route.query.orderId,
      reportType: query.reportType || this.$route.query.reportType,
      appointmentId: query.appointmentId || this.$route.query.appointmentId,
      supply: query.supply || this.$route.query.supply, //是否补充凭证
      soundImg: require('../images/sound.png'),
      reportDesc: '',
      photoVideoFiles: [],
      audioFiles: [],
      historyReportDesc: '',
      historyReportType: '',
      historyInfo: {},
      imgVideoUploadLoading: false,
      audioLoading: false,
      submitLoading: false,
      reportText: {
        doorRecycling: '我司承诺对举报人信息严格保密，经核实成功后，最高可获得5000元现金奖励',
        storeRecycling: '我司承诺对举报人信息严格保密，经核实成功后，最高可获得3000元现金奖励'
      }
    };
  },
  computed: {
    canSubmit() {
      return !this.reportDesc || this.imgVideoUploadLoading || this.audioLoading;
    },
    showNotice() {
      return decodeURI(this.reportType) != '服务问题'
    }
  },
  methods: {
    changeAudioLoading(isLoading) {
      this.imgVideoUploadLoading = isLoading;
    },
    // 限制音频长度
    limitDuration(file) {
      return new Promise((resolve) => {
        if (file) {
          const url = URL.createObjectURL(file);
          const video = document.createElement('video');
          video.addEventListener('loadedmetadata', function () {
            if (video.duration > 3600) {
              resolve(true)
            } else {
              resolve(false)
            }
            URL.revokeObjectURL(url);
          });
          video.src = url;
        }
      })
    },
    async filesAdded(files) {
      this.imgVideoUploadLoading = true;
      const arr = Object.keys(files);
      let imgNum = 0;
      let videoNum = 0;
      let filterInfo = '';
      for (let i = 0; i < arr.length; i++) {
        if (files[arr[i]].type.includes('video')) {
          videoNum += 1;
          const isLimit = await this.limitDuration(files[arr[i]])
          if (isLimit) {
            files[arr[i]].ignore = true;
            filterInfo = '视频长度不能超过30分钟!';
          }
        }
        if (!files[arr[i]].type.includes('video')) {
          imgNum += 1;
        }
        if (videoNum >= 2) {
          files[arr[i]].ignore = true;
          filterInfo = '最多上传2个视频';
        }
        if (imgNum >= 6) {
          files[arr[i]].ignore = true;
          filterInfo = '最多上传6张图片';
        }
      }
      filterInfo && Toast(filterInfo);
    },
    fileSuccess() {
      this.imgVideoUploadLoading = false;
    },
    disabledSubmit() {
      if (!this.reportDesc) {
        Toast('请填写举报描述')
      }
    },
    closePage() {
      native.close();
    },
    submit() {
      // 防止重复提交：如果正在提交中，直接返回
      if (this.submitLoading) {
        return
      }
      const reportEvidence = [...(this.photoVideoFiles || []).map(item => ({ url: item.url, name: item.name })), ...(this.$refs.audioUploadRef.filelist || []).map(item => ({ url: item.url, name: item.name }))]
      this.submitLoading = true;
      if (this.supply == 1) {
        const params = {
          reportDesc: this.reportDesc,
          historyId: this.historyInfo.historyId,
          orderId: this.orderId,
          reportEvidence: JSON.stringify(reportEvidence)
        };
        supplementCaseTrackReport(params).then(() => {
          this.submitLoading = false;
          native.skipToUrl({
            targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/supervise/result?orderId=${this.orderId}&reportSource=${this.reportSource}`,
            needClose: 1
          })
        })
      } else {
        const params = {
          reportSource: this.reportSource,
          reportDesc: this.reportDesc,
          orderId: this.orderId,
          reportType: decodeURIComponent(this.reportType),
          reportEvidence: JSON.stringify(reportEvidence)
        };
        if (this.appointmentId) {
          params.appointmentId = this.appointmentId
        }
        getSubmitCaseTrackReport(params).then(() => {
          this.submitLoading = false;
          native.skipToUrl({
            targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/supervise/result?orderId=${this.orderId}&reportSource=${this.reportSource}`,
            needClose: 1
          })
        })
      }
    },
    fileClick(data) {
      console.log('看看对象', data)
      if (/image/g.test(data.type)) {
        ImagePreview({
          images: [data.url],
          showClose: true,
          showLoading: true
        });
      }
      if (/video/g.test(data.type)) {
        ImagePreview({
          videoVos: [{
            auto: false,
            muteBtn: false,
            controls: true,
            videoUrl: data.url
          }],
          startPosition: 0,
          withVideo: true,
          showClose: true,
          adaptHeight: true,
          adaptApp: true,
          showLoading: true
        });
      }
    }
  },
  created() {
    native.wrap('setHeaderVisible')({
      visible: '0'
    })
    if (this.supply == '1') {
      const params = {
        reportSource: this.reportSource,
        orderId: this.orderId
      }
      getCaseTrackStatusByOrderId(params).then(res => {
        this.historyInfo = res;
      })
    }
    lego.send({
      pagetype: 'SUPERVISE',
      actiontype: 'ENTRY_COMMIT_PAGE',
      backup: {
        uid: getCookie('uid')
      }
    })
  },
  components: {
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-cell': Cell,
    'z-cell-group': CellGroup,
    'z-field': Field,
    'z-upload': Upload,
    'z-button': Button,
    'z-button-group': ButtonGroup,
    UploadAudio,
    ReportInfo
  }
};
</script>

<style lang='less' scoped>
@import "index.less";
</style>
